import React from 'react';
import { NavLink } from 'react-router';
import { tv } from '@/utils/tv';

export const sidebarItem = tv({
  base: 'text-subhead-14 flex cursor-pointer items-center justify-center gap-4 rounded-2xl px-4 py-3 transition-colors lg:w-full lg:justify-start',
  variants: {
    isActive: {
      true: 'bg-info-surface text-primary contrast:bg-primary/10',
      false: 'text-muted-foreground hover:bg-hover',
    },
  },
});

interface Props {
  to: string;
  label: string;
  icon: React.ReactNode;
  iconActive?: React.ReactNode;
  end?: boolean;
  hasBadge?: boolean;
  trailing?: React.ReactNode;
}

export const SidebarItem: React.FC<Props> = ({
  to,
  label,
  icon,
  iconActive,
  end,
  hasBadge = false,
  trailing,
}) => (
  <NavLink
    to={to}
    end={end}
    data-sidebar-item
    className={({ isActive }) => sidebarItem({ isActive })}
  >
    {({ isActive }) => (
      <>
        <span className="relative flex size-6 shrink-0 items-center justify-center">
          {isActive && iconActive ? iconActive : icon}
          {hasBadge && (
            <span className="absolute top-0.5 -right-0.5 size-2 rounded-full border-[1px] border-card bg-accent" />
          )}
        </span>
        <span className="hidden flex-1 truncate lg:inline">{label}</span>
        {trailing}
      </>
    )}
  </NavLink>
);
